import { createBrowserRouter, Navigate } from 'react-router-dom';
import { RootLayout } from './RootLayout';
import { NotFoundPage } from './NotFoundPage';
import { LoginPage } from '@/features/auth/LoginPage';
import { SignupPage } from '@/features/auth/SignupPage';
import { PrivacyPage } from './PrivacyPage';
import { PublicShamanPage } from '@/features/booking/PublicShamanPage';
import { BookingFlowPage } from '@/features/booking/BookingFlowPage';
import { BookingDetailPage } from '@/features/booking/BookingDetailPage';
import { CancelPage } from '@/features/booking/CancelPage';
import { ShamanLayout } from '@/features/shaman/ShamanLayout';
import { ShamanHomePage } from '@/features/shaman/ShamanHomePage';
import { ShamanBookingsPage } from '@/features/shaman/ShamanBookingsPage';
import { ShamanAvailabilityPage } from '@/features/shaman/ShamanAvailabilityPage';
import { ShamanPaymentsPage } from '@/features/shaman/ShamanPaymentsPage';
import { ShamanBillingPage } from '@/features/shaman/ShamanBillingPage';
import { AdminLayout } from '@/features/admin/AdminLayout';
import { AdminShamansPage } from '@/features/admin/AdminShamansPage';
import { AdminPricingPage } from '@/features/admin/AdminPricingPage';
import { AdminBookingsPage } from '@/features/admin/AdminBookingsPage';
import { AdminSubscriptionsPage } from '@/features/admin/AdminSubscriptionsPage';

export const router = createBrowserRouter([
  {
    element: <RootLayout />,
    errorElement: <NotFoundPage />,
    children: [
      { index: true, element: <Navigate to="/login" replace /> },
      { path: 'login', element: <LoginPage /> },
      { path: 'signup', element: <SignupPage /> },
      { path: 'privacy', element: <PrivacyPage /> },
      { path: 'b/:slug', element: <PublicShamanPage /> },
      { path: 'book/:slug', element: <BookingFlowPage /> },
      { path: 'booking/:bookingId', element: <BookingDetailPage /> },
      { path: 'cancel/:token', element: <CancelPage /> },
      {
        path: 'me',
        element: <ShamanLayout />,
        children: [
          { index: true, element: <ShamanHomePage /> },
          { path: 'bookings', element: <ShamanBookingsPage /> },
          { path: 'availability', element: <ShamanAvailabilityPage /> },
          { path: 'payments', element: <ShamanPaymentsPage /> },
          { path: 'billing', element: <ShamanBillingPage /> },
        ],
      },
      {
        path: 'admin',
        element: <AdminLayout />,
        children: [
          { index: true, element: <Navigate to="shamans" replace /> },
          { path: 'shamans', element: <AdminShamansPage /> },
          { path: 'pricing', element: <AdminPricingPage /> },
          { path: 'bookings', element: <AdminBookingsPage /> },
          { path: 'subscriptions', element: <AdminSubscriptionsPage /> },
        ],
      },
    ],
  },
]);
